import { gql } from "@apollo/client";

export const CREATE_PROFILE = gql`
  mutation updateProfileV2($data: ProfileUpdateInputV2!) {
    updateProfileV2(
      data: $data
    ) {
      success,
      messages,
    }
  }`;

export const UPDATE_PROFILE = gql`
  mutation updateProfile($data: ProfileUpdateInput!) {
    updateProfile(
      data: $data
    ) {
      profile {
        id,
        firstName,
        lastName,
        countryCode,
        phone,
        email,
        channelFoundUs,
        isEmailConfirmed,
        location,
      },
      success,
      messages,
    }
  }`;
